import { render, staticRenderFns } from "./FFoldBox.vue?vue&type=template&id=380b918f&"
import script from "./FFoldBox.vue?vue&type=script&lang=js&"
export * from "./FFoldBox.vue?vue&type=script&lang=js&"
import style0 from "./FFoldBox.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports